import React from 'react';

const randomThreeDigits = () => Math.floor(Math.random()*(999-100+1)+100);

const suggestUserNameByEmail = (email) => {
  const suggested = email.substr(0, email.indexOf('@')).replace(/[^0-9a-z]/gi, '');
  return suggested + randomThreeDigits();
};

export default class UsernameField extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      value: '',
    };

    this.handleOnChange = this.handleOnChange.bind(this);
    this.doneTyping = this.doneTyping.bind(this);
  }

  componentDidMount() {
    this.suggestUsername();
  }

  suggestUsername() {
    const emailEl = window.document.getElementById('user_email');

    if (emailEl) {
      const email = emailEl.value;

      if (email) {
        this.handleOnChange({ target: { value: suggestUserNameByEmail(email) }});
      }
    }
  }

  handleOnChange(event) {
    const username = event.target.value;
    this.setState({ username });

    clearTimeout(window.typingTimer);
    window.typingTimer = setTimeout(this.doneTyping, 1000);
  }

  doneTyping() {
    const username = this.state.username;

    this.setState({
      message: `Validating '${this.state.username}' as username...`,
      messageClass: 'small with-margin'
    });

    $.get(`/username_validation?username=${username}`).then(response => {
      this.setState({ valid: response.isUsernameValid });
      if (response.isUsernameValid) {
        this.setState({
          message: 'This username is valid!',
          messageClass: 'success'
        });
      } else {
        this.setState({
          message: 'This username is not valid. Please choose another one.',
          messageClass: 'error'
        });
      }
    });
  }

  render() {
    return (
      <div>
        <input
          className="form-control"
          type="text"
          onChange={this.handleOnChange}
          placeholder={this.props.placeholder}
          name="user[username]"
          className="input input-pill"
          value={this.state.username}
          style={{ marginBottom: 0 }}/>
        { this.state.message &&
          <span className={this.state.messageClass}>
            { this.state.message}
          </span>
        }
      </div>
    )
  }
}
